import { Toaster } from '@app/components/ui/sonner';
import AppLayoutTemplate from '@app/layouts/app/app-sidebar-layout';
import { type BreadcrumbItem } from '@app/types';
import { ReactNode } from 'react';
import ThemeEditor from '@app/components/theme-editor';

interface AppLayoutProps {
    children: ReactNode;
    breadcrumbs?: BreadcrumbItem[];
}

export default ({ children, ...props }: AppLayoutProps) => {

    return (
        <AppLayoutTemplate {...props}>
            {children}
            <Toaster />
            <ThemeEditor />
        </AppLayoutTemplate>
    );
};
